import * as React from "react";

import { Icon, SystemIcon } from "@storeblocks/icon";
import { H2, Paragraph } from "App/global-style";
import { useComponentTexts, useProductTexts } from "Store/texts/hooks";
import { Link, useLocation } from "react-router-dom";
import { BoldParagraph, FlexContainer, LinkGroup, Surface } from "./styled";

import { MainPath } from "Constants/constants";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { TextLanguage } from "Store/texts/interfaces";
import { useUserIdentificationSelector } from "Store/userIdentification/userIdentificationSelectors";
import { isDefined } from "Utils/functions";
import { replacePlaceholder } from "Utils/replacePlaceholder";
import { PATH } from "../carConstants";
import { CAR_FIND_STEP } from "../carSteps";
import { Reason } from "./enums";

function getDescription(
  reason: Reason,
  texts: any,
  lang: TextLanguage,
): string {
  if (!isDefined(reason)) {
    return "";
  }

  return texts[reason][lang];
}

export const InvalidInsuranceObject = (): React.ReactElement => {
  const userIdentification = useUserIdentificationSelector();
  const cartId = userIdentification?.newCartResponse.cartId;

  const location = useLocation<{ reason: Reason }>();
  const reason = location.state.reason;
  const [
    {
      tile: { invalidInsuranceObject: texts },
    },
    lang,
  ] = useProductTexts(getFMSProductName(INSURANCE_NAME_VALUE.CAR));
  const [{ contactUs }] = useComponentTexts();

  return (
    <>
      <H2>{texts.heading[lang]}</H2>
      <Paragraph>{getDescription(reason, texts, lang)}</Paragraph>
      <Surface>
        <FlexContainer>
          <Icon name="mobile" />
          <BoldParagraph
            dangerouslySetInnerHTML={{
              __html: replacePlaceholder(contactUs.description[lang], {
                phoneNumber: contactUs.phoneNumber[lang],
              }),
            }}
          />
        </FlexContainer>
      </Surface>
      <LinkGroup>
        <Link to={`${MainPath.OFFER}/${cartId}`}>
          {texts.toCart[lang]} <SystemIcon name="arrow-right" />
        </Link>
        <a href="https://www.storebrand.no/privat/forsikring">
          {texts.toInsuranceOverview[lang]} <SystemIcon name="arrow-right" />
        </a>
        <Link to={`${PATH}/${CAR_FIND_STEP.id}`}>{texts.back[lang]}</Link>
      </LinkGroup>
    </>
  );
};
